import {useFormik} from "formik";
import {InputText} from "primereact/inputtext";
import {UserService} from "../services/UserService";
import {Button} from "primereact/button";
import { classNames } from 'primereact/utils';
import React, {useContext} from "react";
import {AuthContext} from "../App";

export default function SpotifyAppForm({onSaveApp, newApp}) {
    const userservice = new UserService();
    const auth = useContext(AuthContext);

    const formik = useFormik({
        initialValues: newApp,
        validate: (data) => {
            let errors = {};

            if (!data.displayname) {
                errors.displayname = 'Displayname is required.';
            }

            if (!data.id && !data.client_id) {
                errors.client_id = 'Client_id is required.';
            }

            if (!data.id && !data.client_secret) {
                errors.client_secret = 'Client_secret is required.';
            }

            return errors;
        },
        onSubmit: (data) => {
            if(data.id){
                userservice.updateSpotifyApp(data, auth.getAccessToken()).then((res) => {
                    if(res.status === 200) {
                        res.json().then(data => {
                            onSaveApp(false, data);
                            formik.resetForm();
                        })
                    }
                    else
                    {
                        console.error("something went wrong");
                    }
                })
            } else {
                userservice.createSpotifyApp(data, auth.getAccessToken()).then((res) => {
                    if(res.status === 200) {
                        res.json().then(data => {
                            onSaveApp(true, data);
                            formik.resetForm();
                        })
                    }
                    else
                    {
                        console.error("something went wrong");
                    }
                })
            }


        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return(
        <div className="flex justify-content-center">
            <div className="card form-demo">
                <div className="mb-2">
                    <ul className="list-unstyled">
                        <li>Displayname is just for here, to distinguish apps in case you create more than one.</li>
                        <li>Client_id: must be the client_id of the Developer App in Spotify - generated here: <a  href='https://developer.spotify.com/dashboard'>Spotify Dev Link</a> </li>
                        <li>Client_secret: must correspond to the client_id</li>
                    </ul>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid">

                    <div className="field">
                        <span className="p-float-label">
                            <InputText id="displayname" name="displayname" value={formik.values.displayname} onChange={formik.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid('displayname') })} />
                            <label htmlFor="displayname" className={classNames({ 'p-error': isFormFieldValid('displayname') })}>Display Name</label>
                        </span>
                        {getFormErrorMessage('displayname')}
                    </div>

                    <div className="field">
                        <span className="p-float-label">
                            <InputText id="client_id" name="client_id" value={formik.values.client_id} onChange={formik.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid('client_id') })} />
                            <label htmlFor="client_id" className={classNames({ 'p-error': isFormFieldValid('client_id') })}>Client_id</label>
                        </span>
                        {getFormErrorMessage('client_id')}
                    </div>

                    <div className="field">
                        <span className="p-float-label">
                            <InputText id="client_secret" name="client_secret" value={formik.values.client_secret} onChange={formik.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid('client_secret') })} />
                            <label htmlFor="client_secret" className={classNames({ 'p-error': isFormFieldValid('client_secret') })}>Client_secret</label>
                        </span>
                        {getFormErrorMessage('client_secret')}
                    </div>

                    <Button type="submit" label={formik.values.id? "Update" : "Create"} className="mt-2"/>
                </form>
            </div>
        </div>
    )
}